import { trunc } from './trunc';
/**
 * Returns fractional part of a number
 * @example getFraction(5.25) === 0.25
 * !NOTE: floating point rounding errors are possible
 * @example getFraction(3.14) === 0.14000000000000012
 */
export function getFraction(x: number): number {
  return Math.abs(x - trunc(x));
}
